import { Splide } from '@splidejs/splide';

export default () => {
	const sections = document.querySelectorAll('.brand-showcase');
	
	sections.forEach(function(section) {
		const sliderWrappers = section.querySelectorAll('.splide');

		sliderWrappers.forEach(function(sliderEl) {
			const slides = sliderEl.querySelectorAll('.splide__slide');
			
			const shouldInitialize = window.innerWidth >= 768 ? slides.length > 3 : slides.length > 2;
			
			if (!shouldInitialize) return;

			const splide = new Splide(sliderEl, {
				type: 'loop',
				pagination: false,
				arrows: true,
				speed: 400,
				gap: '1px',
				perPage: 4,
				perMove: 1,
				drag: 'free',
				autoplay: false,
				
				breakpoints: {
					767: {
						perPage: 1,
						focus: false,
						arrows: false,
						drag: true,
						snap: true,
					},
				}
			});

			splide.mount();

			// Handle window resize to reinitialize if needed
			let resizeTimer;
			window.addEventListener('resize', function() {
				clearTimeout(resizeTimer);
				resizeTimer = setTimeout(function() {
					const newShouldInitialize = window.innerWidth >= 768 ? slides.length > 4 : slides.length > 2;
					
					if (newShouldInitialize && !splide.state.is(Splide.STATES.DESTROYED)) {
					} else if (newShouldInitialize && splide.state.is(Splide.STATES.DESTROYED)) {
						splide.mount();
					} else if (!newShouldInitialize && !splide.state.is(Splide.STATES.DESTROYED)) {
						splide.destroy();
					}
				}, 250);
			});
		});
	});
}